import React, { useEffect, useRef } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { shape, string } from 'prop-types';
import { Button } from '../../components';
import classes from './collections.module.css';

var CollectionItem = function CollectionItem(_ref) {
  var item = _ref.item,
      onSelect = _ref.onSelect,
      restorationValue = _ref.restorationValue;
  var collectionItemRef = useRef();
  var history = useHistory();
  var collections_id = item.collections_id;
  useEffect(function () {
    if (!restorationValue) {
      return;
    }

    collectionItemRef.current.scrollIntoView({
      behavior: 'auto',
      block: 'center'
    });
  });
  return React.createElement("div", {
    className: "text-center mb-0 sm_mb-8 lg_mb-0",
    ref: collectionItemRef
  }, React.createElement(Link, {
    to: "/collection-landing/".concat(item.collection_url),
    "aria-label": "Read more about ".concat(item.name, " Collection")
  }, React.createElement("div", {
    className: classes.collectionImageWrapper
  }, React.createElement("img", {
    src: item.image,
    alt: item.name,
    className: classes.collectionItemImage
  })), React.createElement("div", {
    className: "".concat(classes.collectionTitleName, " mt-4 h5")
  }, item.name)), React.createElement("div", {
    className: "mt-3 flex flex-col items-center"
  }, React.createElement("p", {
    className: classes.ellipsis
  }, item.description), React.createElement(Link, {
    className: "underline mx-auto mb-8 text-bronze",
    to: "/collection-landing/".concat(item.collection_url),
    "aria-label": "Read more about ".concat(item.name),
    onClick: function onClick() {
      return onSelect(collections_id);
    }
  }, "Read more"), React.createElement("div", {
    className: classes.btnCollections
  }, React.createElement(Button, {
    priority: "normal",
    onClick: function onClick() {
      onSelect(collections_id);
      history.push('/collection-landing/' + item.collection_url);
    },
    "aria-label": "View ".concat(item.name, " Collection")
  }, "VIEW COLLECTION"))));
};

CollectionItem.propTypes = {
  item: shape({
    image: string,
    name: string,
    description: string,
    slug: string
  })
};
export default CollectionItem;